"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function updateValue(values, selected, index) {
    return index === values.length
        ? [...values, selected]
        : [...values.slice(0, index), selected, ...values.slice(index + 1)].filter(val => !lodash_1.isNull(val) && !lodash_1.isUndefined(val));
}
exports.default = updateValue;
